import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges, OnChanges, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormControl, AbstractControl, ValidatorFn } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { UtilisateurModel } from './../../../models/utilisateur/utilisateur.model';


@Component({
  selector: 'app-autocomplete-user',
  templateUrl: './autocomplete-user.component.html',
  styleUrls: ['./autocomplete-user.component.scss']
})
export class AutocompleteUserComponent implements OnInit, OnChanges {

  @Input() users: UtilisateurModel[];
  @Input() userId: number;
  @Input() required = false;
  @Input() libelle: string;
  @Output() updated = new EventEmitter<number>();
  realisateursString: string[] = [];
  filteredRealisateur: Observable<string[]>;
  myControl = new UntypedFormControl();
  @ViewChild('matInput') matInput: ElementRef<HTMLInputElement>;


  constructor() { }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges): void {
    this.reLoadObjets();
    if (this.userId && this.users.length) {
      const objet = this.users.find(obj => obj.id === this.userId);
      this.myControl.setValue(objet ? (objet.nom + ' ' + objet.prenom) : '');
    } else {
      this.myControl.setValue('');
    }
  }

  deleteIfEmptyOrNotFound(): void {
    this.myControl.setValue('');
    this.userId = null;
    this.updated.emit(null);
  }

  /* Add or selected with enterKey */
  intervenantChange(value: string): void {
    let user;
    if (value === '') {
      user = null;
      this.userId = null;
    } else {
      user = this.users.find(obj => obj.nom + ' ' + obj.prenom === value);
      if (user) {
        this.userId = this.users.find(obj => obj.nom + ' ' + obj.prenom === value).id;
      }
    }
    this.updated.emit(this.userId);
  }


  reLoadObjets(): void {
    this.realisateursString = [];
    if (this.users !== undefined) {
      for (const objet of this.users) {
        this.realisateursString.push(objet.nom + ' ' + objet.prenom);
      }
      this.realisateursString.sort((a, b) => a.localeCompare(b));
      this.filteredRealisateur = this.myControl.valueChanges.pipe(
        startWith(null),
        map((obj: string | null) => obj ? this._filter(obj) : this.realisateursString.slice(0, 30)));
    }
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.realisateursString.filter(realisateur => realisateur.toLowerCase().indexOf(filterValue) >= 0).slice(0, 30);
  }

}
